import type { BotController } from '../../bot/bot';
import type { BattleEngine } from '../../engine/engine';
import type { CardId, CommandResult, WorldPoint } from '../../engine/types';
import { commandForCurrentTick, type BattleDriver } from './battle-driver';

export class LocalBotDriver implements BattleDriver {
  readonly kind = 'bot' as const;
  readonly localSide = 'player' as const;
  readonly allowsPause = true;
  readonly allowsInput = true;

  constructor(private readonly bot: BotController) {}

  beforeStep(engine: BattleEngine): void {
    const command = this.bot.decide(engine.getView('bot'));
    if (command) engine.enqueue(command);
  }

  afterStep(): void {}

  canAdvance(): boolean { return true; }

  submitCard(engine: BattleEngine, cardId: CardId, position: WorldPoint): CommandResult {
    return engine.enqueue(commandForCurrentTick(engine, this.localSide, cardId, position));
  }

  dispose(): void {}
}
